import React, { useEffect } from "react";
import { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar";
import Dashboard from "./pages/Dashboard";
import Upload from "./pages/Upload";
import Reports from "./pages/Reports";
import ReportDetails from "./pages/ReportDetails";
import Analysis from "./pages/Analysis";
import PrivacyPolicyPopup from "./components/PrivacyPolicyPopup";
import "./App.css";
import Cookies from 'js-cookie';

function Main({ isDarkMode, setIsDarkMode }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [ isRecruiterMode, setIsRecruiterMode] = useState(true);

  const [isDutch, setIsDutch] = useState(Cookies.get('isDutch') === 'true');

  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState({});

  const [cvFile, setCVFile] = useState(null);
  const [mLetterfile, setMLetterFile] = useState(null);
  const [linkedInURL, setLinkedInURL] = useState('');
  const [linkedInData, setLinkedInData] = useState(null);

  //Upload CV
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  //Upload Motivational Letter
  const [uploadMLetterProgress, setUploadMLetterProgress] = useState(0);
  const [uploadMLetterComplete, setUploadMLetterComplete] = useState(false);
  const [uploadMLetterUploading, setUploadMLetterUploading] = useState(false);
  const [uploadMLetterIsDragging, setUploadMLetterIsDragging] = useState(false);
  const [mLetterOption, setMLetterOption] = useState("uploadFile");
  const [mLetterText, setMLetterText] = useState("");

  //Career Preferences
  const [preferencesSummary, setPreferencesSummary] = useState("");

  //Reflection
  const [reflectionSummary, setReflectionSummary] = useState("");
  const [reflectionAnswers, setReflectionAnswers] = useState({
    ambition: "",
    ambitionStrategy: "",
    greatestSuccess: "",
    fitnessRituals: "",
  });

  //Generate PDF
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(true);

  const [careerPreferences, setCareerPreferences] = useState({});
  const [reflection, setReflection] = useState({});

  useEffect(() => {
    if (!Cookies.get('token')) {
      navigate('/login');
    }
  }, []);

  return (
    <div className={`App ${!isGeneratingPDF ? "max-h-screen overflow-hidden" : ""}`}>
      {Cookies.get('token') && (
      <PrivacyPolicyPopup isOpen={showPrivacyPolicy} onClose={() => setShowPrivacyPolicy(false)}
      isDutch={isDutch}
      />
    )}
      {isGeneratingPDF && (
            <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
                <div className="bg-white p-8 rounded-lg w-96">
                    <h2 className="text-2xl font-bold mb-4">Downloading PDF...</h2>
                </div>
            </div>
        )}
      <main>
        <Sidebar
          isDarkMode={isDarkMode}
          setIsDarkMode={setIsDarkMode}
          chats={chats}
          setSelectedChat={setSelectedChat}
          isDutch={isDutch}
          setIsDutch={setIsDutch}
        />
        <div
        className={`flex flex-col flex-1 content  ${isDarkMode ? "dark-mode" : ""} px-20 py-10 ${!isGeneratingPDF ? "max-h-screen" : ""}`}
         id="analysis-report">
          <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/upload" element={<Upload setCVFile={setCVFile} setMLetterFile={setMLetterFile} setLinkedInURL={setLinkedInURL} cvFile={cvFile} mLetterfile={mLetterfile} linkedInURL={linkedInURL} linkedInData={linkedInData} setLinkedInData={setLinkedInData}
          uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} uploadComplete={uploadComplete} setUploadComplete={setUploadComplete} uploading={uploading} setUploading={setUploading} isDragging={isDragging} setIsDragging={setIsDragging}
          uploadMLetterProgress={uploadMLetterProgress} setUploadMLetterProgress={setUploadMLetterProgress} uploadMLetterComplete={uploadMLetterComplete} setUploadMLetterComplete={setUploadMLetterComplete} uploadMLetterUploading={uploadMLetterUploading} setUploadMLetterUploading={setUploadMLetterUploading} uploadMLetterIsDragging={uploadMLetterIsDragging} setUploadMLetterIsDragging={setUploadMLetterIsDragging}
          preferencesSummary={preferencesSummary} setPreferencesSummary={setPreferencesSummary}
          reflectionSummary={reflectionSummary} setReflectionSummary={setReflectionSummary} reflectionAnswers={reflectionAnswers} setReflectionAnswers={setReflectionAnswers}
          mLetterOption={mLetterOption} setMLetterOption={setMLetterOption} mLetterText={mLetterText} setMLetterText={setMLetterText}
          isDutch={isDutch}
          careerPreferences={careerPreferences}
          setCareerPreferences={setCareerPreferences}
          reflection={reflection}
          setReflection={setReflection}
          />} />
          <Route path="/reports" element={<Reports isDutch={isDutch}/>} />
          <Route path="/reports/:id" element={<ReportDetails isGeneratingPDF={isGeneratingPDF} setIsGeneratingPDF={setIsGeneratingPDF} isRecruiterMode={isRecruiterMode} setIsRecruiterMode={setIsRecruiterMode} isDutch={isDutch}/>} />
          <Route path="/analysis" element={<Analysis cvFile={cvFile} mLetterfile={mLetterfile} mLetterOption={mLetterOption} mLetterText={mLetterText} linkedInURL={linkedInURL} linkedInData={linkedInData} isGeneratingPDF={isGeneratingPDF} setIsGeneratingPDF={setIsGeneratingPDF} isRecruiterMode={isRecruiterMode} setIsRecruiterMode={setIsRecruiterMode} preferencesSummary={preferencesSummary} reflectionSummary={reflectionSummary} isDutch={isDutch} careerPreferences={careerPreferences} reflection={reflection}/>} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

export default Main;
